/* KX immersive viewer: snap carousel, FLIP open, click / double-tap zoom with pan, ambient backdrop. No libraries. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var mq = function (q) { return !!(window.matchMedia && window.matchMedia(q).matches); };

  window.kxViewer = function (dlg) {
    if (!dlg || !dlg.showModal) return null;
    var root = document.documentElement;
    var track = $('[data-kx-vtrack]', dlg);
    var slides = $$('.kx-viewer__slide', dlg);
    var imgs = slides.map(function (s) { return $('img', s); });
    var n = slides.length, cur = 0, onClose = null, zoom = null, target = -1, tmo = 0, raf = 0, lastWheel = 0;
    var curEl = $('[data-kx-vcur]', dlg), bar = $('[data-kx-vbar]', dlg), strip = $('.kx-viewer__strip', dlg);
    var sthumbs = $$('[data-kx-vthumb]', dlg), amb = $$('.kx-viewer__amb span', dlg), ambI = 0;
    var reduce = mq('(prefers-reduced-motion: reduce)');
    var Z = 2.4;
    var hint = $('[data-kx-vhint]', dlg);
    if (hint) hint.textContent = hint.getAttribute(mq('(pointer: coarse)') ? 'data-touch' : 'data-desk') || '';

    function pad(x) { return (x < 10 ? '0' : '') + x; }
    function ready(img) { img.classList.add('is-loaded'); img.parentNode.classList.add('is-ready'); }
    imgs.forEach(function (img) { img.addEventListener('load', function () { ready(img); }); });
    function full(img) { img.srcset = img.getAttribute('data-srcset') || ''; img.src = img.getAttribute('data-src'); }
    function hydrate(i, placeholder) {
      var img = imgs[i];
      if (!img || img.getAttribute('data-kx-h')) return Promise.resolve(img);
      img.setAttribute('data-kx-h', '1');
      if (!placeholder) { full(img); return Promise.resolve(img); }
      img.src = placeholder;
      var p = img.decode ? img.decode() : Promise.resolve();
      return p.catch(function () {}).then(function () {
        img.style.transition = 'none'; ready(img); void img.offsetWidth; img.style.transition = '';
        full(img);
        return img;
      });
    }
    function setAmbient(i) {
      var u = imgs[i] && imgs[i].getAttribute('data-thumb');
      if (!u || amb.length < 2) return;
      ambI = 1 - ambI;
      amb[ambI].style.backgroundImage = 'url("' + u + '")';
      amb[ambI].classList.add('is-on');
      amb[1 - ambI].classList.remove('is-on');
    }
    function update(i, force) {
      if (i === cur && !force) return;
      if (zoom) unzoom(true);
      cur = i;
      if (curEl) curEl.textContent = pad(i + 1);
      if (bar) bar.style.width = ((i + 1) / n * 100) + '%';
      sthumbs.forEach(function (b, k) {
        b.classList.toggle('is-active', k === i);
        if (k === i) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
      });
      if (strip && sthumbs[i]) {
        var li = sthumbs[i].parentNode;
        strip.scrollTo({ left: li.offsetLeft - (strip.clientWidth - li.offsetWidth) / 2, behavior: reduce ? 'auto' : 'smooth' });
      }
      [i, i + 1, i - 1].forEach(function (k) { if (k >= 0 && k < n) hydrate(k); });
      setAmbient(i);
    }
    function go(i, instant) {
      if (n < 2) return;
      i = (i + n) % n;
      target = i; clearTimeout(tmo); tmo = setTimeout(function () { target = -1; }, 900);
      track.scrollTo({ left: i * track.clientWidth, behavior: (instant || reduce) ? 'auto' : 'smooth' });
      update(i);
    }
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        var w = track.clientWidth || 1;
        if (target >= 0) { if (Math.abs(track.scrollLeft - target * w) < 2) target = -1; else return; }
        var i = Math.round(track.scrollLeft / w);
        if (i !== cur && i >= 0 && i < n) update(i);
      });
    }, { passive: true });

    /* zoom */
    function box(img) {
      var r = img.getBoundingClientRect();
      var ar = (img.naturalWidth && img.naturalHeight) ? img.naturalWidth / img.naturalHeight : ((+img.getAttribute('width') || 1) / (+img.getAttribute('height') || 1));
      var w = Math.min(r.width, r.height * ar), h = w / ar;
      return { l: r.left + (r.width - w) / 2, t: r.top + (r.height - h) / 2, w: w, h: h, bl: r.left, bt: r.top, bw: r.width, bh: r.height };
    }
    function paint(t) { zoom.img.style.transition = t || 'none'; zoom.img.style.transform = 'translate(' + zoom.tx + 'px,' + zoom.ty + 'px) scale(' + zoom.z + ')'; }
    function limits() { return { x: Math.max(0, (zoom.cw * zoom.z - zoom.bw) / 2), y: Math.max(0, (zoom.ch * zoom.z - zoom.bh) / 2) }; }
    function clamp() { var m = limits(); zoom.tx = Math.max(-m.x, Math.min(m.x, zoom.tx)); zoom.ty = Math.max(-m.y, Math.min(m.y, zoom.ty)); }
    function zoomAt(img, x, y) {
      var b = box(img), cx = b.bl + b.bw / 2, cy = b.bt + b.bh / 2;
      zoom = { img: img, z: Z, cw: b.w, ch: b.h, bl: b.bl, bt: b.bt, bw: b.bw, bh: b.bh, tx: -(x - cx) * (Z - 1), ty: -(y - cy) * (Z - 1) };
      clamp(); dlg.classList.add('is-zoomed');
      paint(reduce ? 'none' : 'transform .45s cubic-bezier(.2,.85,.25,1)');
    }
    function unzoom(instant) {
      if (!zoom) return;
      var img = zoom.img; zoom = null;
      img.style.transition = (instant || reduce) ? 'none' : 'transform .38s cubic-bezier(.2,.85,.25,1)';
      img.style.transform = '';
      dlg.classList.remove('is-zoomed');
    }
    function inside(b, e) { return e.clientX >= b.l && e.clientX <= b.l + b.w && e.clientY >= b.t && e.clientY <= b.t + b.h; }

    slides.forEach(function (sl, i) {
      var fr = $('.kx-viewer__frame', sl), img = imgs[i];
      var ptype = 'mouse', sx = 0, sy = 0, moved = false, drag = null, lastTap = 0;
      sl.addEventListener('click', function (e) { if (e.target === sl && !zoom) close(); });
      fr.addEventListener('pointerdown', function (e) {
        ptype = e.pointerType || 'mouse'; sx = e.clientX; sy = e.clientY; moved = false;
        if (zoom && zoom.img === img && ptype !== 'mouse') {
          drag = { x: e.clientX, y: e.clientY, tx: zoom.tx, ty: zoom.ty };
          try { fr.setPointerCapture(e.pointerId); } catch (err) {}
        }
      });
      fr.addEventListener('pointermove', function (e) {
        if (Math.abs(e.clientX - sx) + Math.abs(e.clientY - sy) > 8) moved = true;
        if (!zoom || zoom.img !== img) return;
        if (drag) { zoom.tx = drag.tx + (e.clientX - drag.x); zoom.ty = drag.ty + (e.clientY - drag.y); clamp(); paint(); }
        else if ((e.pointerType || 'mouse') === 'mouse') {
          var m = limits();
          zoom.tx = m.x * (1 - 2 * (e.clientX - zoom.bl) / zoom.bw);
          zoom.ty = m.y * (1 - 2 * (e.clientY - zoom.bt) / zoom.bh);
          paint('transform .12s linear');
        }
      });
      var end = function () { drag = null; };
      fr.addEventListener('pointerup', end);
      fr.addEventListener('pointercancel', end);
      fr.addEventListener('click', function (e) {
        if (ptype === 'mouse') {
          if (zoom) { unzoom(); return; }
          if (moved) return;
          if (inside(box(img), e)) zoomAt(img, e.clientX, e.clientY); else close();
          return;
        }
        if (moved) return;
        var now = Date.now();
        if (now - lastTap < 320) { lastTap = 0; if (zoom) unzoom(); else zoomAt(img, e.clientX, e.clientY); }
        else lastTap = now;
      });
    });

    dlg.addEventListener('wheel', function (e) {
      if (zoom) { e.preventDefault(); return; }
      if (Math.abs(e.deltaY) > Math.abs(e.deltaX) && Math.abs(e.deltaY) > 18) {
        e.preventDefault();
        var now = Date.now();
        if (now - lastWheel > 550) { lastWheel = now; go(cur + (e.deltaY > 0 ? 1 : -1)); }
      }
    }, { passive: false });
    dlg.addEventListener('keydown', function (e) {
      var k = e.key;
      if (k === 'ArrowRight') { e.preventDefault(); go(cur + 1); }
      else if (k === 'ArrowLeft') { e.preventDefault(); go(cur - 1); }
      else if (k === 'Home') { e.preventDefault(); go(0); }
      else if (k === 'End') { e.preventDefault(); go(n - 1); }
    });
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); if (zoom) unzoom(); else close(); });
    dlg.addEventListener('close', function () {
      root.classList.remove('kx-lock');
      dlg.classList.remove('is-in', 'is-zoomed');
      if (zoom) unzoom(true);
      if (onClose) { var cb = onClose; onClose = null; cb(cur); }
    });
    $$('[data-kx-vclose]', dlg).forEach(function (b) { b.addEventListener('click', function () { close(); }); });
    $$('[data-kx-vprev]', dlg).forEach(function (b) { b.addEventListener('click', function () { go(cur - 1); }); });
    $$('[data-kx-vnext]', dlg).forEach(function (b) { b.addEventListener('click', function () { go(cur + 1); }); });
    sthumbs.forEach(function (b) { b.addEventListener('click', function () { go(+b.getAttribute('data-kx-vthumb') || 0); }); });
    window.addEventListener('resize', function () { if (dlg.open) { unzoom(true); track.scrollLeft = cur * track.clientWidth; } });

    function close() {
      if (!dlg.open) return;
      unzoom(true);
      dlg.classList.remove('is-in');
      setTimeout(function () { if (dlg.open) dlg.close(); }, reduce ? 0 : 280);
    }
    function flip(img, from) {
      var s = from.getBoundingClientRect(), b = box(img);
      if (!s.width || !b.w || !img.animate) return;
      var sc = s.width / b.w, dx = (s.left + s.width / 2) - (b.l + b.w / 2), dy = (s.top + s.height / 2) - (b.t + b.h / 2);
      img.animate([{ transform: 'translate(' + dx + 'px,' + dy + 'px) scale(' + sc + ')' }, { transform: 'translate(0px,0px) scale(1)' }], { duration: 560, easing: 'cubic-bezier(.2,.85,.25,1)' });
    }
    function open(i, opts) {
      if (dlg.open) return;
      opts = opts || {};
      onClose = opts.onClose || null;
      i = Math.max(0, Math.min(n - 1, i || 0));
      root.classList.add('kx-lock');
      dlg.showModal();
      track.scrollLeft = i * track.clientWidth;
      target = -1;
      var p = hydrate(i, opts.placeholder);
      update(i, true);
      requestAnimationFrame(function () { dlg.classList.add('is-in'); });
      if (opts.from && !reduce) p.then(function (img) { if (img) flip(img, opts.from); });
      var cb = $('[data-kx-vclose]', dlg);
      if (cb) { try { cb.focus({ preventScroll: true }); } catch (err) { cb.focus(); } }
    }
    return { open: open, close: close, go: go };
  };
})();